import { Avatar, Badge } from '@mui/material'
import React from 'react'

import { Icon } from '#/components/Icon'
import Colors from '#/styles/Colors'
import OldColors from '#/styles/Old/Colors'

export default function AlertIcon(props) {
  const { event_type, virtual_type, health_status, dtr } = props

  if (event_type === 'success') {
    return (
      <Avatar style={{ backgroundColor: Colors.success }}>
        <Icon size="large" name="check-bold" />
      </Avatar>
    )
  }

  if (event_type === 'success-with-warnings') {
    return (
      <Avatar style={{ backgroundColor: Colors.warning }}>
        <Icon size="large" name="exclamation-thick" />
      </Avatar>
    )
  }

  if (event_type === 'failed') {
    return (
      <Avatar style={{ backgroundColor: Colors.danger }}>
        <Icon size="large" name="close-thick" />
      </Avatar>
    )
  }

  if (event_type === 'queued' || event_type === 'started') {
    return (
      <Avatar style={{ backgroundColor: Colors.info }}>
        <Icon size="large" name="timer-sand" />
      </Avatar>
    )
  }

  if (event_type?.match(/reproduction*/)) {
    if (event_type?.match(/birth*/)) {
      return (
        <Avatar style={{ backgroundColor: OldColors.delivery_alert }}>
          <Icon size="large" name="favorite-border" style={{ color: '#fff' }} />
        </Avatar>
      )
    }
    return (
      <Badge
        color="primary"
        variant="dot"
        invisible={!dtr}
        slotProps={{
          badge: {
            style: {
              top: 5,
              right: 5,
              backgroundColor: Colors.dtr[dtr],
            },
          },
        }}
      >
        <Avatar style={{ backgroundColor: OldColors.heat_alert }}>
          <Icon size="large" name="reproduction" style={{ color: '#fff' }} />
        </Avatar>
      </Badge>
    )
  }

  if (event_type?.match(/health.condition*/)) {
    if (virtual_type === 'health.condition_confirmation.user') {
      return (
        <Avatar style={{ backgroundColor: OldColors.milk_return }}>
          <Icon size="large" name="opacity" style={{ color: '#fff' }} />
        </Avatar>
      )
    }
    return (
      <Avatar
        style={{
          backgroundColor:
            health_status === 'critical'
              ? OldColors.health_critical_alert
              : OldColors.health_observation_alert,
        }}
      >
        <Icon size="large" name="health" style={{ color: '#fff' }} />
      </Avatar>
    )
  }

  if (event_type?.match(/rumination*/)) {
    return (
      <Avatar style={{ backgroundColor: OldColors.nutrition_alert }}>
        <Icon size="large" name="corn" style={{ color: '#fff' }} />
      </Avatar>
    )
  }

  if (event_type?.match(/farm*/)) {
    if (event_type?.match(/connected*/)) {
      return (
        <Avatar style={{ backgroundColor: Colors.map.markers.ccom.operational }}>
          <Icon size="large" name="connected" color="#fff" />
        </Avatar>
      )
    }
    return (
      <Avatar style={{ backgroundColor: Colors.map.markers.ccom.offline }}>
        <Icon size="large" name="disconnected" color="#fff" />
      </Avatar>
    )
  }

  if (event_type?.match(/ccom*/)) {
    if (event_type?.match(/connected*/)) {
      return (
        <Avatar style={{ backgroundColor: Colors.map.markers.ccom.operational }}>
          <Icon size="large" name="connected" color="#fff" />
        </Avatar>
      )
    }
    return (
      <Avatar style={{ backgroundColor: Colors.map.markers.ccom.offline }}>
        <Icon size="large" name="disconnected" color="#fff" />
      </Avatar>
    )
  }

  return (
    <Avatar style={{ backgroundColor: Colors.info }}>
      <Icon size="large" name="bell" />
    </Avatar>
  )
}
